import React from 'react';

const CommunicationVariablesContext = React.createContext({});

export default CommunicationVariablesContext;
